export const autoDiagQueryKeys = {
  detail: (siteId: number) => ["auto-diag", siteId] as const,
  startLinkAutoDiag: (siteId: number) => [...autoDiagQueryKeys.detail(siteId), "test-link"] as const,
  modulators: (siteId: number) => [...autoDiagQueryKeys.detail(siteId), "modulators"] as const,
};
